import { render, staticRenderFns } from "./UsersAdmininstrationDialog.vue?vue&type=template&id=1cbf6846"
import script from "./UsersAdmininstrationDialog.vue?vue&type=script&lang=js"
export * from "./UsersAdmininstrationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports